import { createSlice } from '@reduxjs/toolkit';
import { readLocalePreference, resolveLocale } from './localePreference';
import { readModePreference } from './modePreference';
import { readSideNavPreference } from './sideNavPreference';
import { themeConfig } from '@/configs/theme.config';

const initialNavMode = () => {
	if (themeConfig.layout.type === 'modern' && themeConfig.navMode !== 'themed') {
		return 'transparent';
	}

	return themeConfig.navMode;
};

const initialState = {
	themeColor: themeConfig.themeColor,
	direction: themeConfig.direction,
	mode: readModePreference() ?? themeConfig.mode,
	locale: resolveLocale(readLocalePreference(), themeConfig.locale),
	primaryColorLevel: themeConfig.primaryColorLevel,
	panelExpand: themeConfig.panelExpand,
	navMode: initialNavMode(),
	layout: {
		...themeConfig.layout,
		sideNavCollapse: readSideNavPreference() ?? themeConfig.layout.sideNavCollapse
	}
};

const availableNavColorLayouts = [
	'classic',
	'stackedSide',
	'decked'
];

export const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		setDirection: (state, action) => {
			state.direction = action.payload
		},
		setMode: (state, action) => {

			const availableColorNav = availableNavColorLayouts.includes(state.layout.type)

			if (availableColorNav && action.payload === 'dark' && state.navMode !== 'themed') {
				state.navMode = 'dark'
			}
			if (availableColorNav && action.payload === 'light' && state.navMode !== 'themed') {
				state.navMode = 'light'
			}
			state.mode = action.payload
		},
		setLang: (state, action) => {
			state.locale = action.payload
		},
		setLayout: (state, action) => {
			state.cardBordered = action.payload === 'modern'
			if (action.payload === 'modern') {
				state.navMode = 'transparent'
			}

			const availableColorNav = availableNavColorLayouts.includes(action.payload)

			if (availableColorNav && state.mode === 'light') {
				state.navMode = 'light'
			}

			if (availableColorNav && state.mode === 'dark') {
				state.navMode = 'dark'
			}

			state.layout = {
				...state.layout,
				...{ type: action.payload }
			}
		},
		setPreviousLayout: (state, action) => {
			state.layout.previousType = action.payload
		},
		setSideNavCollapse: (state, action) => {
			state.layout = {
				...state.layout,
				...{ sideNavCollapse: action.payload }
			}
		},
		setNavMode: (state, action) => {
			if (action.payload !== 'default') {
				state.navMode = action.payload
			} else {
				if (state.layout.type === 'modern') {
					state.navMode = 'transparent'
				}

				const availableColorNav = availableNavColorLayouts.includes(state.layout.type)

				if (availableColorNav && state.mode === 'light') {
					state.navMode = 'light'
				}

				if (availableColorNav && state.mode === 'dark') {
					state.navMode = 'dark'
				}
			}
		},
		setPanelExpand: (state, action) => {
			state.panelExpand = action.payload
		},
		setThemeColor: (state, action) => {
			state.themeColor = action.payload
		},
		setThemeColorLevel: (state, action) => {
			state.primaryColorLevel = action.payload
		},
	},
});

export const {
	setDirection,
	setMode,
	setLang,
	setLayout,
	setSideNavCollapse,
	setNavMode,
	setPanelExpand,
	setThemeColor,
	setThemeColorLevel,
	setPreviousLayout
} = themeSlice.actions;

export default themeSlice.reducer;
